<template>
  <tab-layout :actionBar="true">
    <horse-confirm-details slot="tabContent" class="tab-pane row mx-0 show active" :nominate="nominate" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import HorseRegisterConfirmDetails from './HorseRegisterConfirmDetails'

export default {
  name: 'HorseConfirm',
  props: ['nominate'],
  components: {
    'tab-layout': tabLayout,
    'horse-confirm-details': HorseRegisterConfirmDetails
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Horses/Register/HorseRegisterConfirm.vue